import { Company } from '../company';
import { CompanyAccess } from '../company-access';

export class CompanyBuilder {
  static companyFromJson(json): Company {
    return (json)
      ? new Company(
        json.hash,
        json.name,
        json.email,
        json.minEmployees,
        json.maxEmployees,
        json.companyRegistrationNumber,
        json.address,
        json.province,
        json.postalCode
      )
      : null;
  }

  static companyAccessFromJson(json): CompanyAccess {
    return (json)
      ? new CompanyAccess(
        json.email
      )
      : null;
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/builders/company.builder.ts